import React, { useMemo } from "react";

export const Fireflies = ({ count = 24, className = "" }) => {
  // Positions/timings are locked in once per mount — otherwise every parent
  // re-render (a keystroke in a form field, a cart update, anything) reruns
  // Math.random() and yanks every firefly to a new spot mid-flight. The
  // memoized array keeps them drifting smoothly regardless of app state.
  const flies = useMemo(
    () => Array.from({ length: count }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      delay: Math.random() * 8,
      duration: 6 + Math.random() * 8,
      size: 3 + Math.random() * 6,
    })),
    [count]
  );
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
      {flies.map((f) => (
        <span
          key={f.id}
          className="firefly"
          style={{
            left: `${f.left}%`,
            top: `${f.top}%`,
            width: f.size,
            height: f.size,
            animationDelay: `${f.delay}s`,
            animationDuration: `${f.duration}s`,
          }}
        />
      ))}
    </div>
  );
};
